import React, { useContext, useEffect, useState } from 'react';
import StatCards, { StatCardColor } from "../../../common/stat-cards/stat-cards";
import AttendanceTable from "../../component/attendance-table";
import { CalendarDays, CalendarHeart, LogOut, UserRoundCheck, UserRoundX } from "lucide-react";
import { IEmployeeAttendanceState } from "../../attendance.types";
import { fetchMyAttendance, fetchSummary } from "../actions";
import dayjs from "dayjs";
import AttendanceSearchContext from "../../AttendanceContext";
import { scrollToAttendanceTable } from "../../utils";


const initialState = {
    summary: {
        holidays: 0,
        presentDays: 0,
        absentDays: 0,
        leaveDays: 0,
        weekends: 0,
        month: '',
    },
    isSummaryLoading: false

}

const EmployeeAttendanceList = ({employeeId}: { employeeId: string }) => {

    const [state, setState] = useState<IEmployeeAttendanceState>(initialState)
    const {setAttendanceSearch}=useContext(AttendanceSearchContext);

    useEffect(() => {
        loadSummary();
    }, []);

    async function loadSummary() {
        setState((prev) => ({
            ...prev,
            isLoading: true
        }));
        const res = await fetchSummary(employeeId);
        const currMonth = dayjs().format('MMMM');
        const currMonthRes = res.months.filter((item: any) => item.month.toLowerCase() === currMonth.toLowerCase());
        if (currMonthRes) {
            setState((prev) => ({
                ...prev,
                summary: currMonthRes[0],
                isLoading: false
            }));
        }
    }


    const AttendanceCards = [
        {
            key: 'total',
            label: 'Weekend Days',
            value: state.summary.weekends,
            icon: CalendarDays,
            color: 'default' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'WEEKEND');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'present',
            label: 'Days Present',
            value: state.summary.presentDays,
            icon: UserRoundCheck,
            color: 'green' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'PRESENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'absent',
            label: 'Days Absent',
            value: state.summary.absentDays,
            icon: UserRoundX,
            color: 'red' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'ABSENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'holiday',
            label: 'Holidays',
            value: state.summary.holidays,
            icon: CalendarHeart,
            color: 'default' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'HOLIDAY');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'leave',
            label: 'Leaves Taken',
            value: state.summary.leaveDays,
            icon: LogOut,
            color: 'orange' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'ON_LEAVE');
                scrollToAttendanceTable();
            }
        }
    ]


    function fetchAttendanceApi(page: number, size?: number, startDate?: string, endDate?: string,employeeId?:string, sortField?: string,sortDirection?: string,
                                status?:string) {

        return fetchMyAttendance(employeeId!, page, size, startDate, endDate, sortField, sortDirection,status);
    }

    return (
        <>
            <StatCards data={AttendanceCards} size={'small'} loading={state.isSummaryLoading}/>

            <AttendanceTable
                title={'Attendance Details'}
                showPunchOnClick={false}
                isActionVisible={false}
                fetchAttendanceApi={fetchAttendanceApi}
            />
        </>
    )

}


export default EmployeeAttendanceList;
